<template>
    <div class="main-div">
        <div class="inc-header">
            <div class="inc-header-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20.0963 15.6056L15.6806 13.6266L15.6694 13.6209C15.44 13.5227 15.1897 13.4833 14.9412 13.5062C14.6927 13.5291 14.4538 13.6136 14.2463 13.7522C14.2218 13.7683 14.1984 13.7858 14.1759 13.8047L11.8941 15.75C10.4484 15.0478 8.95595 13.5666 8.25376 12.1397L10.2019 9.82312C10.2206 9.79968 10.2384 9.77624 10.2553 9.75093C10.3907 9.54403 10.4729 9.30686 10.4945 9.06053C10.5161 8.8142 10.4764 8.56636 10.3791 8.33906C10.3787 8.33531 10.3787 8.33155 10.3791 8.32781L8.39438 3.90374C8.2657 3.6068 8.04444 3.35945 7.76362 3.19859C7.4828 3.03774 7.1575 2.97202 6.83626 3.01124C5.56592 3.17841 4.39986 3.80228 3.55588 4.76633C2.7119 5.73039 2.24771 6.9687 2.25001 8.24999C2.25001 15.6937 8.30626 21.75 15.75 21.75C17.0313 21.7523 18.2696 21.2881 19.2337 20.4441C20.1977 19.6001 20.8216 18.4341 20.9888 17.1637C21.028 16.8425 20.9623 16.5172 20.8014 16.2364C20.6406 15.9556 20.3932 15.7343 20.0963 15.6056ZM15.75 20.25C12.5685 20.2465 9.51825 18.9811 7.26856 16.7314C5.01888 14.4818 3.75348 11.4315 3.75001 8.24999C3.74648 7.33451 4.07631 6.44905 4.67789 5.75897C5.27947 5.06889 6.11167 4.62137 7.01907 4.49999C7.0187 4.50373 7.0187 4.5075 7.01907 4.51124L8.98782 8.91749L7.05001 11.2369C7.03034 11.2595 7.01247 11.2836 6.99657 11.3091C6.85549 11.5255 6.77273 11.7748 6.7563 12.0327C6.73988 12.2906 6.79035 12.5483 6.90282 12.7809C7.7522 14.5181 9.50251 16.2553 11.2584 17.1037C11.4928 17.2152 11.752 17.2639 12.0108 17.2452C12.2696 17.2264 12.5192 17.1409 12.735 16.9969C12.7593 16.9806 12.7825 16.9628 12.8044 16.9434L15.0834 15L19.4897 16.9744C19.4897 16.9744 19.4972 16.9744 19.5 16.9744C19.3799 17.8829 18.933 18.7165 18.2428 19.3194C17.5526 19.9223 16.6664 20.2531 15.75 20.25ZM12.75 7.49999C12.75 7.30108 12.829 7.11032 12.9697 6.96966C13.1103 6.82901 13.3011 6.74999 13.5 6.74999H15.75V4.49999C15.75 4.30108 15.829 4.11032 15.9697 3.96966C16.1103 3.82901 16.3011 3.74999 16.5 3.74999C16.6989 3.74999 16.8897 3.82901 17.0303 3.96966C17.171 4.11032 17.25 4.30108 17.25 4.49999V6.74999H19.5C19.6989 6.74999 19.8897 6.82901 20.0303 6.96966C20.171 7.11032 20.25 7.30108 20.25 7.49999C20.25 7.69891 20.171 7.88967 20.0303 8.03032C19.8897 8.17098 19.6989 8.24999 19.5 8.24999H17.25V10.5C17.25 10.6989 17.171 10.8897 17.0303 11.0303C16.8897 11.171 16.6989 11.25 16.5 11.25C16.3011 11.25 16.1103 11.171 15.9697 11.0303C15.829 10.8897 15.75 10.6989 15.75 10.5V8.24999H13.5C13.3011 8.24999 13.1103 8.17098 12.9697 8.03032C12.829 7.88967 12.75 7.69891 12.75 7.49999Z"
                        fill="#71717B"
                    />
                </svg>
                <p>New Secure Call</p>
            </div>
        </div>
        <div class="num-div">
            <span> {{dialNumber}}</span>
        </div>
        <div class="actions-div">
            <div class="action-wrapper">
                <PrimeButton @click="dialNumber = ''" label="Clear Number" class="w-full p-btn-root_contrast" variant="contrast"> </PrimeButton>
                <PrimeButton @click="closeDialog, useDynamicDialog(ModalNames.OUTGOING_CALL_CONNECTED)" label="Place Call" class="w-full p-btn-root_success" variant="success">
                    <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path
                                d="M18.6156 13.6781C18.4763 14.7367 17.9564 15.7084 17.1531 16.4117C16.3497 17.1151 15.3177 17.5019 14.25 17.5C8.04688 17.5 3.00001 12.4531 3.00001 6.24996C2.99809 5.18222 3.38492 4.15029 4.08824 3.34691C4.79155 2.54353 5.76326 2.02364 6.82188 1.88434C7.08958 1.85165 7.36067 1.90642 7.59468 2.04046C7.8287 2.17451 8.01309 2.38064 8.12032 2.62809L9.77032 6.31168V6.32106C9.85242 6.51047 9.88633 6.71728 9.86901 6.92299C9.8517 7.12871 9.7837 7.32693 9.6711 7.49996C9.65704 7.52106 9.64219 7.54059 9.62657 7.56012L8.00001 9.48825C8.58516 10.6773 9.82891 11.9101 11.0336 12.4968L12.9352 10.8789C12.9538 10.8632 12.9734 10.8486 12.9938 10.8351C13.1666 10.7198 13.3655 10.6494 13.5725 10.6303C13.7794 10.6112 13.9878 10.644 14.1789 10.7257L14.1891 10.7304L17.8695 12.3797C18.1174 12.4865 18.3241 12.6707 18.4585 12.9048C18.593 13.1388 18.6481 13.4101 18.6156 13.6781Z"
                                fill="white"
                            />
                        </svg>
                    </template>
                </PrimeButton>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useDynamicDialog } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';
import { useContactsTempStore } from '~/stores/person/contacts-temp';

const store = useContactsTempStore();

const dialNumber = ref(store.selectedContact?.phone_numbers[0]?.phone_full || '555-867-5309');

const emit = defineEmits(['closeDialog']);

const closeDialog = () => {
    emit('closeDialog');
};
</script>
<style lang="scss" scoped>
.main-div {
  @apply flex flex-col items-center sm:max-w-md sm:w-[440px] w-11/12 mx-auto h-auto rounded-lg p-6 gap-4 rounded-xl bg-zinc-950;
}
.inc-header {
  @apply flex flex-col justify-center items-start self-stretch;

  .inc-header-div {
    @apply flex items-center gap-4 self-stretch;

    p {
      @apply text-zinc-500 font-inter text-sm font-normal leading-7;
    }
  }
}
.num-div {
  @apply flex flex-col items-center gap-1 py-6 self-stretch;

  span {
    @apply w-full text-zinc-50 text-center font-inter text-4xl font-semibold leading-7;
  }
}
.actions-div {
  @apply flex items-start gap-6 self-stretch;

  .action-wrapper {
    @apply w-full flex flex-row items-center gap-6 justify-center;
  }
}
</style>

